var path = '/components/directives/customfield/ace.tpl.html';
var html = "<div ui-ace=\"field.definition.aceOptions\"  ng-model=\"field.ngModel\" style=\"width: 100%; min-height: 500px\"></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/customfield/ace.tpl.html
// module id = 1977
// module chunks = 1